// S2 葫芦配件
import { FC, useRef } from 'react'
import clsx from 'clsx'
import { IS2 } from '@/common/pd-meta-components-types'
import gsap from 'gsap'
import { useGSAP } from '@gsap/react'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import PdMedia from '@/components/pd-media/pd-media'
import { useMobileDetector } from '@/hooks/use-mobile-detector'
import TitleAndDesc from '../../title-and-desc'

gsap.registerPlugin(useGSAP, ScrollTrigger)

const S2: FC<IS2> = ({ theme, infoItemList = [], mediaUrlList = [] }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const firstTitleRef = useRef<HTMLDivElement>(null)
  const secondTitleRef = useRef<HTMLDivElement>(null)
  const sideMediaRef = useRef<HTMLDivElement>(null)
  const rearMediaRef = useRef<HTMLDivElement>(null)
  const trayMediaRef = useRef<HTMLDivElement>(null)
  useGSAP(() => {
    if (!mediaUrlList.length) return
    ScrollTrigger.refresh()

    const isMobile = window.innerWidth < 1024
    const tl = gsap.timeline({
      scrollTrigger: {
        scroller: '#main',
        trigger: containerRef.current,
        start: 'top top',
        end: () => `+=${window.innerHeight * 5}`,
        pin: true,
        pinType: 'fixed',
        scrub: 1,
      },
    })

    tl.to(firstTitleRef.current, {
      opacity: 0,
    }).fromTo(
      secondTitleRef.current,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        y: 0,
      }
    )

    tl.to(
      sideMediaRef.current,
      {
        x: isMobile ? '-6.75rem' : '-27.375rem',
      },
      '<'
    )
      .to(
        rearMediaRef.current,
        {
          x: isMobile ? '4.8rem' : '29rem',
          opacity: 0,
        },
        '<'
      )
      .fromTo(
        trayMediaRef.current,
        {
          opacity: 0,
        },
        {
          opacity: 0.3,
          y: isMobile ? '3.1rem' : '6.3rem',
        }
      )
      .to(sideMediaRef.current, {
        x: 0,
      })
      .to(
        trayMediaRef.current,
        {
          opacity: 1,
          x: isMobile ? '-5.6rem' : '-29.1rem',
        },
        '<'
      )

    return () => {
      tl.kill()
    }
  }, [mediaUrlList])
  return (
    <div
      className={clsx(
        'w-full h-fit',
        'py-15 laptop:py-30 overflow-hidden',
        `pd-theme-${theme}`,
        'bg-container-primary',
        'pointer-events-none min-h-screen'
      )}
      ref={containerRef}
    >
      <div className={clsx('w-full h-144px relative', 'mb-8 laptop:mb-16')}>
        <div ref={firstTitleRef} className={clsx('absolute', 'left-0 right-0 top-0 bottom-0')}>
          <TitleAndDesc title={infoItemList?.[0]?.title || ''} desc={infoItemList?.[0]?.desc || ''} />
        </div>
        <div ref={secondTitleRef} className={clsx('absolute left-0 right-0 bottom-0')}>
          <TitleAndDesc
            title={infoItemList?.[1]?.title || ''}
            desc={infoItemList?.[1]?.desc || ''}
            descClass="!mb-0 laptop:!mb-0"
          />
        </div>
      </div>
      <div className={clsx('w-full max-w-300 mx-auto relative', 'h-359px laptop:h-776px', 'px-6 laptop:px-0')}>
        <div className={clsx('w-full h-full relative')}>
          <div
            className={clsx(
              'absolute z-[2]',
              'w-159px h-359px left-108px laptop:w-324px laptop:h-776px laptop:left-438px'
            )}
            ref={sideMediaRef}
          >
            <PdMedia src={mediaUrlList?.[0] || ''} mask={false} object="fill" />
          </div>
          <div
            className={clsx(
              'absolute z-[3]',
              'w-22 h-250px left-162px top-3 laptop:w-189px laptop:h-541px laptop:left-547px laptop:top-25px'
            )}
            ref={rearMediaRef}
          >
            <PdMedia src={mediaUrlList?.[1] || ''} mask={false} object="fill" />
          </div>
          <div
            className={clsx(
              'absolute z-[1] right-0',
              'w-22 h-122px top-90px laptop:w-195px laptop:h-272px laptop:top-202px'
            )}
            ref={trayMediaRef}
          >
            <PdMedia src={mediaUrlList?.[2] || ''} mask={false} object="fill" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default S2
